import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import useFormatDate from '../../current-locale/use-format-date'
import { DocumentErrorCode, DocumentErrorDetails } from '../error-handler.backend-types'
import { getNegativeVatMessage } from './negative-vat'

export function useDocumentErrorMessage() {
  const { t } = useTranslation()
  const formatDate = useFormatDate()

  const getCoreErrorMessage = useCallback(
    function getDocumentErrorMessage<N extends DocumentErrorCode>(code: N, details?: unknown): string | null {
      try {
        switch (code) {
          case DocumentErrorCode.CASHDESK_CLOSED:
            return null
          case DocumentErrorCode.COUNTER_DUPLICATED:
            return null
          case DocumentErrorCode.CUSTOMER_INVALID:
            return null
          case DocumentErrorCode.DOCUMENT_NOT_ALIGNED:
            return null
          case DocumentErrorCode.NEGATIVE_VAT:
            return getNegativeVatMessage(t, details as DocumentErrorDetails<'NEGATIVE_VAT'>)
        }
        return checkSwitchExhaustive(code)
      } catch (error) {
        return null
      }
    },
    [t, formatDate],
  )

  return getCoreErrorMessage
}

function checkSwitchExhaustive(x: never): never {
  throw new Error('Switch not exhaustive')
}
